/* External */
import {
  useMemo,
  useEffect,
  useState,
  useRef,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';

/* Storage */
import { fetchPageById, selectPageByPageInfo } from '../storage/pages';

/* Utils */
import { STATUS_TYPES } from '../utils/constants';
import useRequestAndDelete from './useRequestAndDelete';

export default function useFetchPage(pageId, sourceProvider, sportIds) {
  const [requestId, setRequestId] = useState(undefined);
  const wasFetchDispatched = useRef(false);
  const dispatch = useDispatch();

  const pageSelector = useMemo(
    () => selectPageByPageInfo({ id: pageId, sportIds }),
    [pageId, sportIds],
  );
  const page = useSelector(pageSelector);

  const request = useRequestAndDelete(requestId);

  useEffect(() => {
    wasFetchDispatched.current = false;
  }, [pageId]);

  useEffect(() => {
    if (!wasFetchDispatched.current && pageId) {
      const action = fetchPageById(pageId, sourceProvider, sportIds);
      setRequestId(action.requestId);
      dispatch(action);
      wasFetchDispatched.current = true;
    }
  }, [dispatch, pageId, sourceProvider, sportIds]);

  return {
    page,
    /* Show the loading state only when there is nothing to render yet. If
       the page is already in the store (a previous visit cached it), render
       it immediately and let the fetch below refresh it silently in the
       background — otherwise every route re-entry flashes the whole-page
       skeleton even though the data is already available. */
    isFetching: !page
      && (request ? request?.status === STATUS_TYPES.INIT_STATE : true),
  };
}
